var lib_core = require("lib-core");
var Geometry = require("lib-geometry");

/**
 * Attach some extra functions so that the geometry objects can be used in a versioned context.
 */
module.exports.Coord = Geometry.Coord;
lib_core.JsonParser.registerClass(Geometry.Coord, "Coordinate");

Geometry.Coord.prototype.getData = function() {
    var data = {};
    data['x'] = this.x;
    data['y'] = this.y;
    return data;
};

Geometry.Coord.prototype.setData = function(data) {
    this.x = data['x'];
    this.y = data['y'];
    this.taintCache();
};

/**
 * Attach some extra functions so that the geometry objects can be used in a versioned context.
 */
module.exports.Coord3d = Geometry.Coord3d;
lib_core.JsonParser.registerClass(Geometry.Coord3d, "Coord3d");

Geometry.Coord3d.prototype.getData = function() {
    var data = {};
    data['x'] = this.x;
    data['y'] = this.y;
    data['z'] = this.z;
    return data;
};

Geometry.Coord3d.prototype.setData = function(data) {
    this.x = data['x'];
    this.y = data['y'];
    this.z = data['z'];
    this.taintCache();
};



module.exports.Line = Geometry.Line;
lib_core.JsonParser.registerClass(Geometry.Line, "Line");

Geometry.Line.prototype.getData = function() {
    var data = {};
    data['dir']   = this.dir;
    data['point'] = this.point;
    return data;
};

Geometry.Line.prototype.setData = function(data) {
    this.dir   = data['dir'];
    this.point = data['point'];
};


module.exports.Segment = Geometry.Segment;
lib_core.JsonParser.registerClass(Geometry.Segment, "Segment");

Geometry.Segment.prototype.getData = function() {
    var data = {};
    data['a'] = this.a;
    data['b'] = this.b;
    return data;
};

Geometry.Segment.prototype.setData = function(data) {
    this.a = data['a'];
    this.b = data['b'];
};

module.exports.BoundingBox = Geometry.BoundingBox;
lib_core.JsonParser.registerClass(Geometry.BoundingBox, "BoundingBox");

Geometry.BoundingBox.prototype.getData = function() {
    var data = {};
    data['x'] = this.x;
    data['y'] = this.y;
    data['width'] = this.x;
    data['height'] = this.y;
    return data;
};

Geometry.BoundingBox.prototype.setData = function(data) {
    this.x = data['x'];
    this.y = data['y'];
    this.width = data['width'];
    this.height = data['height'];
};

module.exports.Polygon = Geometry.Polygon;
lib_core.JsonParser.registerClass(Geometry.Polygon, "Polygon");

Geometry.Polygon.prototype.getData = function() {
    var data = {};
    data['points'] = this.points.map(function(point) { return point.getData(); });
    return data;
};

Geometry.Polygon.prototype.setData = function(data) {
    this.points = data['points'].map(function (p) {
        var point = new Geometry.Coord();
        point.setData(p);
        return point;
    });
};

module.exports.ComplexPolygon = Geometry.ComplexPolygon;
lib_core.JsonParser.registerClass(Geometry.ComplexPolygon, "ComplexPolygon");

Geometry.ComplexPolygon.prototype.getData = function() {
    var data = Geometry.Polygon.prototype.getData.call(this);
    data.holes = this.holes.map(function(hole) {
        return hole.map(function(point) { return point.getData(); });
    });
    return data;
};

Geometry.ComplexPolygon.prototype.setData = function(data) {
    Geometry.Polygon.prototype.setData.call(this, data);
    this.holes = data.holes.map(function(hole) {
        return hole.map(function (p) {
            var point = new Geometry.Coord();
            point.setData(p);
            return point;
        });
    });
};

module.exports.MultiPolygon = Geometry.MultiPolygon;
lib_core.JsonParser.registerClass(Geometry.MultiPolygon, "MultiPolygon");

Geometry.MultiPolygon.prototype.getData = function() {
    var data = {};
    data.polygons = this.polygons.map(function(polygon) { return polygon.getData();});
    return data;
};

Geometry.MultiPolygon.prototype.setData = function(data) {
    this.polygons = data.polygons.map(function (polygon) {
        var poly = new Geometry.Polygon(polygon.points);
        return poly;
    });
};

Geometry.Transform.fromVersionedElement = function(element) {
    var transform = new Geometry.Transform();
    transform.translation = element.pos();
    transform.angle = element.angle();
    return transform;
};
